// features.js — MVP feature flags for the Steptember launch.
//
// Set to `false` to hide entry points (nav, dashboard tiles, settings)
// while KEEPING the route code intact so we can flip them back on for
// v2 without a big merge.  Routes themselves stay registered — a user
// with a deep-link will still reach the page, but casual users have no
// way to discover them.
//
// Rule of thumb: if a feature is on this list, the *entry point* is
// hidden but the underlying code stays untouched.

export const FEATURES = {
    // ── CORE (MVP — always on) ─────────────────────────────────────
    MAP_CORE:       true,   // Crew map pins, friends, meetups, invites
    CHALLENGES:     true,   // Challenges + chat (steps-only for MVP)
    MEETUPS:        true,   // Doodle-style meetup wizard
    CHATS:          true,   // Bottom-nav chats tab
    AI_TWIN:        true,   // Twin coach — steps-only mode
    HEALTH_SYNC:    true,   // Apple HealthKit / Google Fit steps sync

    // ── KOELKAST (hidden for MVP, keep code) ───────────────────────
    TERRITORY:      false,  // Wyngx Territory polyline claim + stealing
    AI_FRIDGE:      false,
    SMART_GROCERY:  false,
    NUTRITION:      false,
    FUTURE_YOU:     false,
    WYNGX_CARD:     false,
    WHEEL:          false,
    TWIN_BATTLE:    false,  // AI Twin *battle* mode (single-user twin OK)
    PATH_SYSTEM:    false,
    VOICE_JOURNAL:  false,
    SORA_VIDEO:     false,
    POSE_DETECTION: false,
    SHOP_HISTORY:   false,
    MULTI_METRIC:   false,  // Challenges beyond steps
};

// Convenience: `if (isEnabled("TERRITORY")) …`
export const isEnabled = (key) => FEATURES[key] === true;

// MVP allow-list for challenge metrics.  Everything else stays in the
// backend VALID_METRICS but the frontend picker only shows this one.
export const MVP_METRICS = ["steps"];

// MVP allow-list for dashboard tiles / visible metrics / goal fields.
// Steptember scope is **STRICT STEPS-ONLY** — no HR, HRV, VO2, sleep,
// recovery, weight, or nutrition metrics anywhere in the app (dashboard,
// settings, twin coach, challenges, meetups).  Michel decision 15 jul 2026.
// These metric keys stay valid on the backend so re-enabling is a one-
// liner post-MVP.
export const MVP_DASHBOARD_METRICS = ["steps"];
export const isMvpMetric = (key) => MVP_DASHBOARD_METRICS.includes(key);
